if (document.querySelector('.check-marks')) {

    // ///////////////////////////////////////////////////////////////
    // Set init height on desktop resos to match all checkmarks panels
    // ///////////////////////////////////////////////////////////////

    function setEqualHeight() {
        const elements = document.querySelectorAll('.check-marks__main');
        
        elements.forEach(function(element) {
            element.style.height = 'auto';
        });
    
        if (window.innerWidth >= 1280) {
            let maxHeight = 0;
    
            elements.forEach(function(element) {
                const elementHeight = element.offsetHeight;
                if (elementHeight > maxHeight) {
                    maxHeight = elementHeight;
                }
            });
    
            elements.forEach(function(element) {
                element.style.height = maxHeight + 'px';
            });
        } else {
            elements.forEach(function(element) {
                element.style.height = 'auto';
            });
        }
    
        elements.forEach(function(element) {
            element.classList.add('check-marks__main--loaded');
        });
    
        const bullets = document.querySelectorAll('.check-marks__bullet');
        bullets.forEach(function(bullet) {
            bullet.classList.add('check-marks__bullet--loaded');
        });
    }
    
    window.addEventListener('resize', setEqualHeight);
    
    setEqualHeight();

    // ///////////////////////////////////////////////////////////////
    // Mechanism for opening the check-marks
    // ///////////////////////////////////////////////////////////////


    document.querySelectorAll('.check-marks__bullet').forEach(bullet => {
        const secondary = bullet.querySelector('.check-marks__secondary');
        const secondaryWrap = bullet.querySelector('.check-marks__secondary-wrap');
        
        function updateHeight() {
            if (bullet.classList.contains('check-marks__bullet--opened') && secondary && secondaryWrap) {
                // Pobierz nową wysokość po zmianie rozmiaru okna
                const wrapHeight = secondaryWrap.offsetHeight + 'px';
                secondary.style.height = wrapHeight;
            }
        }
    
        bullet.addEventListener('click', function () {
            if (secondary && secondaryWrap) {
                if (bullet.classList.contains('check-marks__bullet--opened')) {
                    // Zamknij element
                    secondary.style.height = null;
                    bullet.classList.remove('check-marks__bullet--opened');
                } else {
                    // Otwórz element
                    const wrapHeight = secondaryWrap.offsetHeight + 'px';
                    secondary.style.height = wrapHeight;
                    bullet.classList.add('check-marks__bullet--opened');
                }
            }
        });
    
        // Aktualizuj wysokość na zdarzenie resize
        window.addEventListener('resize', updateHeight);
    });
    
    
    
}